import React from 'react';
import { Button } from './ui/Button';
import { Check, Shield, Lock, Zap } from 'lucide-react';
export function PricingSection() {
  return <section id="checkout" className="py-20 bg-white relative overflow-hidden" data-id="element-99">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-100">
        <div className="absolute -top-20 -right-20 w-96 h-96 bg-coral-100 rounded-full blur-3xl opacity-30" data-id="element-101"></div>
        <div className="absolute bottom-0 left-0 w-72 h-72 bg-sage-100 rounded-full blur-3xl opacity-30" data-id="element-102"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-103">
        <div className="max-w-lg mx-auto" data-id="element-104">
          <div className="bg-white rounded-3xl shadow-2xl border-2 border-coral-100 overflow-hidden transform hover:scale-[1.02] transition-transform duration-300" data-id="element-105">
            {/* Header */}
            <div className="bg-coral-500 p-4 text-center" data-id="element-106">
              <div className="inline-flex items-center gap-2 text-white font-bold text-sm md:text-base animate-pulse" data-id="element-107">
                <Zap size={18} className="fill-current" data-id="element-108" />
                OFERTA ESPECIAL - SOLO HOY
              </div>
            </div>

            <div className="p-8 md:p-10" data-id="element-109">
              <h3 className="text-2xl font-serif font-bold text-center text-dark-900 mb-2" data-id="element-110">
                Protocolo Cortisol OFF
              </h3>
              <p className="text-center text-gray-500 mb-8" data-id="element-111">
                El sistema completo de 14 días
              </p>

              {/* Pricing */}
              <div className="flex flex-col items-center mb-8" data-id="element-112">
                <div className="flex items-center gap-3 mb-2" data-id="element-113">
                  <span className="text-gray-400 line-through text-xl" data-id="element-114">
                    $59.99
                  </span>
                  <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-xs font-bold border border-green-200" data-id="element-115">
                    AHORRAS $50
                  </span>
                </div>
                <div className="text-6xl font-bold text-coral-600 tracking-tight" data-id="element-116">
                  $9.99
                </div>
                <p className="text-gray-400 text-sm mt-2" data-id="element-117">
                  Pago único · Acceso de por vida
                </p>
              </div>

              {/* Features */}
              <ul className="space-y-4 mb-10" data-id="element-118">
                {['Guía completa Protocolo Cortisol OFF (PDF)', 'Plan de 14 días paso a paso', 'Método Circadian Stacking explicado', 'Acceso inmediato tras el pago', 'Garantía de 7 días'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-119">
                    <div className="mt-1 bg-green-100 rounded-full p-1" data-id="element-120">
                      <Check size={14} className="text-green-600" strokeWidth={3} data-id="element-121" />
                    </div>
                    <span className="text-dark-800 font-medium" data-id="element-122">{item}</span>
                  </li>)}
              </ul>

              {/* CTA */}
              <Button variant="primary" fullWidth isCheckout className="py-4 text-xl shadow-coral-500/40 shadow-lg mb-4" data-id="element-123">
                ✨ QUIERO EL PROTOCOLO POR $9.99
              </Button>

              {/* Trust indicators */}
              <div className="flex flex-col gap-3 text-center" data-id="element-124">
                <div className="flex items-center justify-center gap-4 text-xs text-gray-500" data-id="element-125">
                  <span className="flex items-center gap-1" data-id="element-126">
                    <Lock size={12} data-id="element-127" /> Pago 100% seguro
                  </span>
                  <span className="flex items-center gap-1" data-id="element-128">
                    <Zap size={12} data-id="element-129" /> Acceso inmediato
                  </span>
                  <span className="flex items-center gap-1" data-id="element-130">
                    <Shield size={12} data-id="element-131" /> Garantía 7 días
                  </span>
                </div>
                <p className="text-xs text-coral-600 font-medium animate-pulse" data-id="element-132">
                  ⚡ Solo quedan pocas unidades al precio especial
                </p>
              </div>
            </div>
          </div>

          {/* Payment methods image placeholder if needed, or just text */}
          <div className="mt-6 text-center" data-id="element-133">
            <p className="text-xs text-gray-400" data-id="element-134">
              Procesado por Hotmart. Aceptamos tarjetas de crédito, débito y
              PayPal.
            </p>
          </div>
        </div>
      </div>
    </section>;
}